import { IAccommodationBlockParams } from "Bands/types";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { APIService } from "shared/services";
import { IAPIError, IDataKeys, IJSONAPIItem } from "shared/types";

interface IJSONAPIAccommodationBlock {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIAccommodationBlockCollection {
  [IDataKeys.eventAccommodationBlock]: IJSONAPIAccommodationBlock;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class EventAccommodationBlockService {
  static editBlockTitle = ({
    id,
    title,
  }: {
    id: string;
    title: string;
  }): Promise<IJSONAPIAccommodationBlock> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.patch({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(id),
          data: { title },
        });

        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(
          API_ERROR_CODES.PATCH_EVENT_ACCOMMODATION_BLOCK_TITLE
        );
        return reject(error);
      }
    });

  static getBlock = (id: string): Promise<IJSONAPIAccommodationBlockCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.get({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(id),
        });
        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_EVENT_ACCOMMODATION_BLOCK);
        return reject(error);
      }
    });

  static getBlocks = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] }
  ): Promise<IJSONAPIAccommodationBlockCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const blocks: unknown = await APIService.get({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCKS,
          data: queryParams,
        });
        resolve(blocks as IJSONAPIAccommodationBlockCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_EVENT_ACCOMMODATION_BLOCKS);
        return reject(error);
      }
    });

  static createBlock = (
    data: IAccommodationBlockParams
  ): Promise<IJSONAPIAccommodationBlockCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.post({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCKS,
          data,
        });

        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.CREATE_EVENT_ACCOMMODATION_BLOCK);
        return reject(error);
      }
    });

  static deleteBlock = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_EVENT_ACCOMMODATION_BLOCK);
        return reject(error);
      }
    });

  static editBlock = ({
    id,
    data,
  }: {
    id: string;
    data: IAccommodationBlockParams;
  }): Promise<IJSONAPIAccommodationBlock> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await APIService.patch({
          path: API_ENDPOINTS.EVENT_ACCOMMODATION_BLOCK(id),
          data,
        });
        resolve(response);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_EVENT_ACCOMMODATION_BLOCK);
        return reject(error);
      }
    });
}
